module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesUrban@2x.5583b7a.webp";